/**
 *  图片小图替换
 * @param {String} url 图片原地址 
 */
const imgReplace = (url = '') => {
    let new_url = ''
    let index1 = url.indexOf('?')
    let index2 = url.indexOf('@')
    if (index1 > -1) {
        new_url = url.split('?')[0] + '?x-oss-process=image/resize,w_100'
    } else if (index2 > -1) {
        new_url = url.split('@')[0] + '?x-oss-process=image/resize,w_100'
    } else if (url) {
        new_url = url + '?x-oss-process=image/resize,w_100'
    } else {
        new_url = ''
    }
    return new_url
}

/**
 *  获取img的唯一id值
 * @param {String} val 图片id前缀
 */
const getImgId = (val) => {
    return val + parseInt(Math.random()*1000)
}

export {
    imgReplace,
    getImgId,
}